<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
          label="Turnaround"
          :label-cols="2"
          invalid-feedback="Required"
          :state="!$v.turnaround_id.$invalid"
          :horizontal="true"
        >
          <custom-form-radio-group :options="options" v-model="turnaround_id" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CustomFormRadioGroup from "@/components/shared/form/CustomFormRadioGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "TurnAroundSelect",
  components: { CustomFormRadioGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    turnArounds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    options() {
      return this.turnArounds.map((i) => ({
        value: i.id,
        text: `${i.name}<br /><small>${this.formatSurchage(i)}</small>`,
        icon: "hourglass",
      }));
    },
    turnaround_id: {
      get() {
        return this.submission(this.submissionId).turnaround_id;
      },
      set(value) {
        this.UPDATE_SUBMISSION({
          id: this.submissionId,
          value,
          name: "turnaround_id",
        });
      },
    },
  },
  validations: {
    turnaround_id: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    formatSurchage(turnAround) {
      switch (turnAround.surcharge_type) {
        case "percent":
          return `${turnAround.surcharge}% Surcharge`;
        case "flat":
          return `$${turnAround.surcharge} Surcharge`;
      }
      return "Surcharge not specified";
    },
  },
};
</script>
